<!-- Widget Credit History — Display-only, iframe embeddable -->
<div class="bg-transparent py-1">
    <div class="container-fluid px-2">

        <!-- Errors -->
        <div *ngIf="error && !loading" class="text-center py-3">
            <div *ngIf="errorType === 'auth'" class="alert alert-warning py-2 small">
                <i class="fas fa-key me-1"></i> {{ error }}
            </div>
            <div *ngIf="errorType === 'permission'" class="alert alert-danger py-2 small">
                <i class="fas fa-lock me-1"></i> {{ error }}
            </div>
            <div *ngIf="errorType === 'network' || errorType === ''" class="alert alert-danger py-2 small">
                <i class="fas fa-exclamation-triangle me-1"></i> {{ error }}
                <br><button class="btn btn-sm btn-outline-danger mt-1" (click)="loadCredits()"><i class="fas fa-redo me-1"></i>Reintentar</button>
            </div>
        </div>

        <!-- Loading -->
        <div *ngIf="loading" class="text-center py-4">
            <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
            <p class="text-muted small mt-1 mb-0">Cargando créditos...</p>
        </div>

        <ng-container *ngIf="!loading && !error">

            <!-- ============ VIEW 1: LISTA DE CRÉDITOS ============ -->
            <ng-container *ngIf="view === 1">

                <!-- Estadísticas compactas -->
                <div class="row gx-2 mb-2">
                    <div class="col-3">
                        <div class="stat-card stat-pending text-center py-1 px-1">
                            <div class="fz-16 fw-bold">{{ pendingCount }}</div>
                            <div class="fz-10 text-muted">Pendientes</div>
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="stat-card stat-complete text-center py-1 px-1">
                            <div class="fz-16 fw-bold">{{ completedCount }}</div>
                            <div class="fz-10 text-muted">Completados</div>
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="stat-card stat-trash text-center py-1 px-1">
                            <div class="fz-16 fw-bold">{{ trashCount }}</div>
                            <div class="fz-10 text-muted">Anulados</div>
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="stat-card stat-total text-center py-1 px-1">
                            <div class="fz-16 fw-bold">{{ totalCount }}</div>
                            <div class="fz-10 text-muted">Total</div>
                        </div>
                    </div>
                </div>

                <!-- Lista de créditos -->
                <ng-container *ngFor="let item of invoiceCredits">
                    <div class="card card-compact mb-2 shadow-sm">
                        <div class="card-body py-2 px-3">

                            <!-- ID transacción + estatus -->
                            <div class="d-flex justify-content-between align-items-start mb-1">
                                <div>
                                    <span class="text-muted fz-10">ID transacción</span>
                                    <div class="fw-bold fz-12 font-monospace text-primary">{{ item?.identifier }}</div>
                                </div>
                                <span class="badge fz-10"
                                    [ngClass]="{
                                        'text-bg-success': item?.payment_status?.code === 'PaymentComplete',
                                        'text-bg-warning': item?.payment_status?.code === 'PaymentPending',
                                        'text-bg-secondary': item?.payment_status?.code === 'PaymentTrash'
                                    }">
                                    {{ getStatusDisplayName(item?.payment_status?.name) }}
                                </span>
                            </div>

                            <!-- Monto total + fecha -->
                            <div class="row gx-2 mb-1">
                                <div class="col-6">
                                    <span class="text-muted fz-10">Compra financiada</span>
                                    <div class="fw-bold fz-13">{{ item?.totalAmount | currency:'USD':'': '1.2-2' }} <span class="fz-10 text-muted">USD</span></div>
                                </div>
                                <div class="col-6 text-end">
                                    <span class="text-muted fz-10">Fecha</span>
                                    <div class="fz-12">{{ item?.dueDate | date: 'dd/MM/yyyy h:mm a' }}</div>
                                </div>
                            </div>

                            <!-- ID documento + tienda -->
                            <div class="row gx-2 mb-1">
                                <div class="col-6">
                                    <span class="text-muted fz-10">ID documento</span>
                                    <div class="fz-12 font-monospace">{{ item?.merchantNumber || '-' }}</div>
                                </div>
                                <div class="col-6 text-end">
                                    <span class="text-muted fz-10">Tienda</span>
                                    <div class="fz-12">{{ item?.provider_transaction?.shop || '-' }}</div>
                                </div>
                            </div>

                            <!-- Caja + CI Cajero -->
                            <div class="row gx-2 mb-1">
                                <div class="col-6">
                                    <span class="text-muted fz-10">Caja</span>
                                    <div class="fz-12">{{ item?.provider_transaction?.cash_register || '-' }}</div>
                                </div>
                                <div class="col-6 text-end">
                                    <span class="text-muted fz-10">C.I. Cajero</span>
                                    <div class="fz-12">{{ item?.provider_transaction?.user || '-' }}</div>
                                </div>
                            </div>

                            <!-- Plan + cuotas -->
                            <div class="row gx-2 mb-1">
                                <div class="col-6">
                                    <span class="text-muted fz-10">Plan</span>
                                    <div class="fz-12">{{ item?.plan?.name || '-' }}</div>
                                </div>
                                <div class="col-6 text-end">
                                    <span class="text-muted fz-10">Cuotas</span>
                                    <div class="fz-12">{{ item?.plan?.number_installment || item?.plan?.min_number_installment || '-' }}</div>
                                </div>
                            </div>

                            <!-- Montos -->
                            <div class="row gx-2 mb-1">
                                <div class="col-4">
                                    <span class="text-muted fz-10">Inicial</span>
                                    <div class="fz-12 fw-bold">{{ item?.minimumPaymentDue | currency:'USD':'': '1.2-2' }}</div>
                                </div>
                                <div class="col-4 text-center">
                                    <span class="text-muted fz-10">Financiado</span>
                                    <div class="fz-12 fw-bold">{{ item?.amount | currency:'USD':'': '1.2-2' }}</div>
                                </div>
                                <div class="col-4 text-end">
                                    <span class="text-muted fz-10">Pendiente</span>
                                    <div class="fz-12 fw-bold text-danger">{{ item?.dueBalance | currency:'USD':'': '1.2-2' }}</div>
                                </div>
                            </div>

                            <!-- Pagaré -->
                            <div class="mb-1" *ngIf="item?.params?.pagare">
                                <span class="text-muted fz-10">Pagaré</span>
                                <span class="fz-11 ms-1"
                                    [ngClass]="{
                                        'text-success': item?.params?.pagare?.accepted === true,
                                        'text-danger': item?.params?.pagare?.accepted === false,
                                        'text-warning': item?.params?.pagare?.accepted !== true && item?.params?.pagare?.accepted !== false
                                    }">
                                    {{ item?.params?.pagare?.accepted === true ? 'Aceptado' :
                                       item?.params?.pagare?.accepted === false ? 'No aceptado' : 'Por aceptar' }}
                                </span>
                                <span *ngIf="item?.params?.pagare?.date_accepted" class="fz-10 text-muted ms-1">
                                    ({{ item?.params?.pagare?.date_accepted | date: 'dd/MM/yyyy' }})
                                </span>
                            </div>

                            <!-- Botón Ver Cuotas -->
                            <div class="text-end mt-1">
                                <button class="btn btn-sm btn-outline-primary fz-11 py-0 px-2"
                                    (click)="loadInstallments(item)"
                                    [disabled]="loadingInstallments">
                                    <i class="fas fa-list-ol me-1"></i>Ver cuotas
                                    <span *ngIf="loadingInstallments && invoiceSelected?.code === item?.code" class="spinner-border spinner-border-sm ms-1" role="status"></span>
                                </button>
                            </div>

                        </div>
                    </div>
                </ng-container>

                <!-- No data -->
                <div *ngIf="invoiceCredits.length === 0" class="text-center py-3">
                    <i class="fas fa-shopping-cart text-muted fz-25"></i>
                    <p class="text-muted small mt-1 mb-0">No se encontraron créditos registrados</p>
                </div>
            </ng-container>

            <!-- ============ VIEW 2: CUOTAS (INSTALLMENTS) ============ -->
            <ng-container *ngIf="view === 2">

                <!-- Botón volver -->
                <div class="d-flex align-items-center mb-2">
                    <button class="btn btn-sm btn-outline-secondary me-2 py-0 px-2" (click)="closeInstallment()">
                        <i class="fas fa-arrow-left"></i>
                    </button>
                    <span class="fz-13 fw-bold">Detalle de Cuotas</span>
                </div>

                <!-- Invoice header -->
                <div class="card card-compact mb-2 shadow-sm">
                    <div class="card-body py-2 px-3 text-center">
                        <div class="row gx-2">
                            <div class="col-4">
                                <span class="text-muted fz-10">ID Transacción</span>
                                <div class="fz-12 fw-bold text-primary font-monospace">{{ invoiceSelected?.identifier }}</div>
                            </div>
                            <div class="col-4">
                                <span class="text-muted fz-10">Total</span>
                                <div class="fz-12 fw-bold">{{ invoiceSelected?.totalAmount | currency:'USD':'': '1.2-2' }} USD</div>
                            </div>
                            <div class="col-4">
                                <span class="text-muted fz-10">Pendiente</span>
                                <div class="fz-12 fw-bold text-danger">{{ invoiceSelected?.dueBalance | currency:'USD':'': '1.2-2' }} USD</div>
                            </div>
                        </div>
                        <div class="mt-1">
                            <span class="badge text-bg-primary fz-10">Cuotas: {{ installments?.length }}</span>
                        </div>
                    </div>
                </div>

                <!-- Loading installments -->
                <div *ngIf="loadingInstallments" class="text-center py-3">
                    <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
                    <p class="text-muted small mt-1 mb-0">Cargando cuotas...</p>
                </div>

                <!-- Installments list -->
                <ng-container *ngIf="!loadingInstallments">
                    <div *ngFor="let item of installments; let i = index" class="card card-compact mb-2 shadow-sm">
                        <div class="card-body py-2 px-3">

                            <!-- Cuota header -->
                            <div class="d-flex justify-content-between align-items-center mb-1">
                                <span class="fz-13 fw-bold">
                                    {{ item?.installMent?.order < 1 ? 'Inicial' : 'Cuota ' + item?.installMent?.order }}
                                </span>
                                <span class="badge fz-10"
                                    [ngClass]="{
                                        'text-bg-success': item?.installMent?.payment_status?.code === 'PaymentComplete',
                                        'text-bg-warning': item?.installMent?.payment_status?.code !== 'PaymentComplete'
                                    }">
                                    {{ item?.installMent?.payment_status?.name }}
                                </span>
                            </div>

                            <!-- Monto + fecha -->
                            <div class="row gx-2 mb-1">
                                <div class="col-4">
                                    <span class="text-muted fz-10">Total</span>
                                    <div class="fz-12 fw-bold">{{ item?.installMent?.amount | currency:'USD':'': '1.2-2' }} USD</div>
                                </div>
                                <div class="col-4 text-center">
                                    <span class="text-muted fz-10">Fecha</span>
                                    <div class="fz-11">{{ item?.installMent?.date | date: 'dd/MM/yyyy' }}</div>
                                </div>
                                <div class="col-4 text-end">
                                    <span class="text-muted fz-10">F. Pago</span>
                                    <div class="fz-11">{{ item?.installMent?.scheduledPaymentDate | date: 'dd/MM/yyyy' }}</div>
                                </div>
                            </div>

                            <!-- Pagada + por conciliar -->
                            <div class="row gx-2 mb-1">
                                <div class="col-6">
                                    <span class="text-muted fz-10">Pagada</span>
                                    <div class="fz-12 fw-bold">{{ (item?.installMent?.amount - item?.installMent?.dueBalance) | currency:'USD':'': '1.2-2' }} USD</div>
                                </div>
                                <div class="col-6 text-end" *ngIf="item?.totalpaymentReference > 0">
                                    <span class="text-muted fz-10">Por conciliar</span>
                                    <div class="fz-12 fw-bold text-warning">{{ item?.totalpaymentReference | currency:'USD':'': '1.2-2' }} USD</div>
                                </div>
                            </div>

                            <!-- Pagos -->
                            <div *ngIf="item?.payments?.length > 0 || item?.paymentReference?.length > 0" class="border-top pt-1 mt-1">
                                <div class="d-flex justify-content-between align-items-center mb-1">
                                    <span class="fz-11 fw-bold text-secondary">Pagos</span>
                                    <button *ngIf="item?.installMent?.payment_status?.code === 'PaymentComplete'"
                                        class="btn btn-sm btn-link fz-10 p-0"
                                        (click)="loadInstallmentPayments(item?.installMent)"
                                        [disabled]="loadingPayments">
                                        Ver detalle
                                        <span *ngIf="loadingPayments && installMentSelected?.code === item?.installMent?.code" class="spinner-border spinner-border-sm ms-1" role="status"></span>
                                    </button>
                                </div>

                                <!-- Pagos confirmados -->
                                <div *ngFor="let p of item?.payments" class="d-flex justify-content-between align-items-center py-1 payment-row">
                                    <div>
                                        <div class="fz-11">{{ p?.payment?.paymentMethodId || '-' }}</div>
                                        <div class="fz-10 text-muted font-monospace">{{ p?.payment?.code }}</div>
                                    </div>
                                    <div class="text-end">
                                        <div class="fz-12 fw-bold">{{ p?.amount | currency:'USD':'': '1.2-2' }} USD</div>
                                        <span class="badge fz-9" [ngClass]="{'text-bg-success': p?.payment?.reconciled_payment, 'text-bg-warning': !p?.payment?.reconciled_payment}">
                                            {{ p?.payment?.reconciled_payment ? 'Aprobado' : 'Por conciliar' }}
                                        </span>
                                    </div>
                                </div>

                                <!-- Referencias de pago -->
                                <div *ngFor="let p of item?.paymentReference" class="d-flex justify-content-between align-items-center py-1 payment-row">
                                    <div>
                                        <div class="fz-11">{{ p?.payment?.paymentMethodId || '-' }}</div>
                                        <div class="fz-10 text-muted font-monospace">{{ p?.payment?.code }}</div>
                                    </div>
                                    <div class="text-end">
                                        <div class="fz-12 fw-bold">{{ p?.payment?.amount | currency:'USD':'': '1.2-2' }} USD</div>
                                        <span class="badge fz-9" [ngClass]="{'text-bg-success': p?.payment?.reconciled_payment, 'text-bg-warning': !p?.payment?.reconciled_payment}">
                                            {{ p?.payment?.reconciled_payment ? 'Conciliado' : 'Por conciliar' }}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <!-- Faltante -->
                            <div *ngIf="item?.installMent?.total_dueBalance > 0 && invoiceSelected?.payment_status?.code !== 'PaymentTrash'" class="mt-1">
                                <div class="alert alert-warning py-1 px-2 fz-11 mb-0">
                                    <i class="fas fa-exclamation-triangle me-1"></i>
                                    {{ item?.installMent?.total_dueBalance | currency:'USD':'': '1.2-2' }} USD faltantes
                                </div>
                            </div>

                            <!-- Fees / Penalidades -->
                            <div *ngIf="item?.fees?.length > 0" class="border-top pt-1 mt-1">
                                <div class="fz-11 fw-bold text-secondary mb-1">Penalidades</div>
                                <div *ngFor="let fee of item.fees" class="d-flex justify-content-between align-items-center py-1 payment-row">
                                    <div>
                                        <div class="fz-11">Penalización</div>
                                        <span class="badge fz-9"
                                            [ngClass]="{
                                                'text-bg-success': fee?.payment_status?.code === 'PaymentComplete',
                                                'text-bg-secondary': fee?.payment_status?.code === 'PaymentInactivo',
                                                'text-bg-warning': fee?.payment_status?.code === 'PaymentPending'
                                            }">
                                            {{ fee?.payment_status?.name }}
                                        </span>
                                        <div *ngIf="fee?.payment_status?.code === 'PaymentInactivo'" class="fz-10 text-muted">{{ fee?.message }}</div>
                                    </div>
                                    <div class="text-end">
                                        <div class="fz-12 fw-bold">{{ fee.amount | currency:'USD':'': '1.2-2' }} USD</div>
                                        <div *ngIf="fee?.due_balance > 0 && fee?.payment_status?.code !== 'PaymentInactivo'" class="fz-10 text-danger">
                                            {{ fee?.due_balance | currency:'USD':'': '1.2-2' }} USD faltante
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </ng-container>
            </ng-container>

            <!-- ============ VIEW 3: DETALLE DE PAGOS DE CUOTA ============ -->
            <ng-container *ngIf="view === 3">

                <!-- Botón volver -->
                <div class="d-flex align-items-center mb-2">
                    <button class="btn btn-sm btn-outline-secondary me-2 py-0 px-2" (click)="closeInstallment()">
                        <i class="fas fa-arrow-left"></i>
                    </button>
                    <span class="fz-13 fw-bold">Detalle de Pago</span>
                </div>

                <!-- Header cuota -->
                <div class="card card-compact mb-2 shadow-sm">
                    <div class="card-body py-2 px-3 text-center">
                        <span class="text-muted fz-10">ID Transacción</span>
                        <div class="fz-12 fw-bold text-primary font-monospace mb-1">{{ invoiceSelected?.identifier }}</div>
                        <span class="fz-13 fw-bold">
                            {{ installMentSelected?.order < 1 ? 'Pago Inicial' : 'Cuota ' + installMentSelected?.order }}
                        </span>
                    </div>
                </div>

                <!-- Loading -->
                <div *ngIf="loadingPayments" class="text-center py-3">
                    <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
                    <p class="text-muted small mt-1 mb-0">Cargando pagos...</p>
                </div>

                <!-- Payment details -->
                <ng-container *ngIf="!loadingPayments">
                    <div *ngFor="let payment of payment_base" class="card card-compact mb-2 shadow-sm">
                        <div class="card-body py-2 px-3">

                            <!-- Header pago -->
                            <div class="d-flex justify-content-between align-items-center mb-1">
                                <span class="fz-12 fw-bold">Pago</span>
                                <span class="badge fz-10"
                                    [ngClass]="{
                                        'text-bg-success': payment?.payment?.typeTransaction === 'AUTO',
                                        'text-bg-secondary': payment?.payment?.typeTransaction !== 'AUTO'
                                    }">
                                    {{ payment?.payment?.typeTransaction === 'AUTO' ? 'Auto' : 'Manual' }}
                                </span>
                            </div>

                            <!-- Código -->
                            <div class="mb-1">
                                <span class="text-muted fz-10">Código</span>
                                <div class="fz-11 font-monospace">{{ payment?.payment?.code }}</div>
                            </div>

                            <!-- Monto + estatus -->
                            <div class="row gx-2 mb-1">
                                <div class="col-6">
                                    <span class="text-muted fz-10">Monto total</span>
                                    <div class="fz-13 fw-bold">{{ payment?.payment?.amount | currency:'USD':'': '1.2-2' }} USD</div>
                                </div>
                                <div class="col-6 text-end">
                                    <span class="text-muted fz-10">Estatus</span>
                                    <div><span class="badge text-bg-success fz-10">Pago conciliado</span></div>
                                </div>
                            </div>

                            <!-- Fecha + forma de pago -->
                            <div class="row gx-2 mb-1">
                                <div class="col-6">
                                    <span class="text-muted fz-10">Fecha</span>
                                    <div class="fz-11">{{ payment?.payment?.register_payment_date | date: 'dd/MM/yyyy h:mm a' }}</div>
                                </div>
                                <div class="col-6 text-end">
                                    <span class="text-muted fz-10">Forma de Pago</span>
                                    <div class="fz-11">{{ payment?.payment?.payment_method?.name || '-' }}</div>
                                </div>
                            </div>

                            <!-- Nro confirmación -->
                            <div class="mb-1">
                                <span class="text-muted fz-10">Nro. confirmación</span>
                                <div class="fz-11 font-monospace">{{ payment?.payment?.paymentMethodId || '-' }}</div>
                            </div>

                            <!-- Voucher -->
                            <div *ngIf="payment?.payment?.responseAutoConfirm?.voucher" class="border-top pt-1 mt-1">
                                <div class="fz-11 fw-bold text-secondary">Voucher</div>
                                <div *ngIf="payment?.payment?.responseAutoConfirm?.descripcion" class="fz-11 mb-1">{{ payment?.payment?.responseAutoConfirm?.descripcion }}</div>
                                <div class="voucher p-1 text-dark text-uppercase" [innerHTML]="payment?.payment?.responseAutoConfirm?.voucher"></div>
                            </div>

                            <!-- Distribución -->
                            <div *ngIf="payment?.installMentsPayment?.length > 0" class="border-top pt-1 mt-1">
                                <div class="fz-11 fw-bold text-secondary mb-1">Distribución</div>
                                <div *ngFor="let dist of payment?.installMentsPayment" class="d-flex justify-content-between py-1 payment-row">
                                    <div>
                                        <div class="fz-11 text-primary">{{ dist?.installMent?.order < 1 ? 'Inicial' : 'Cuota ' + dist?.installMent?.order }}</div>
                                        <div class="fz-10 text-muted font-monospace">{{ dist?.installMent?.code }}</div>
                                    </div>
                                    <div class="fz-12 fw-bold">{{ dist?.amount | currency:'USD':'': '1.2-2' }} USD</div>
                                </div>
                            </div>

                            <!-- IGTF / Deducciones -->
                            <div *ngIf="payment?.paymen_categ_concept_deduc?.length > 0" class="border-top pt-1 mt-1">
                                <div class="fz-11 fw-bold text-secondary mb-1">Deducciones</div>
                                <ng-container *ngFor="let deduction of payment?.paymen_categ_concept_deduc">
                                    <div *ngIf="deduction?.category_concept_deduction?.concept_deduction?.name === 'IGTF'" class="d-flex justify-content-between py-1 payment-row">
                                        <div>
                                            <span class="fz-11">{{ deduction?.category_concept_deduction?.concept_deduction?.name }}</span>
                                            <span class="fz-10 text-muted ms-1" *ngIf="deduction?.category_concept_deduction?.isPorcent">{{ deduction?.category_concept_deduction?.amount }}%</span>
                                        </div>
                                        <div class="fz-12 fw-bold">{{ deduction?.amount | currency:'USD':'': '1.2-2' }} USD</div>
                                    </div>
                                </ng-container>
                            </div>

                        </div>
                    </div>

                    <!-- No payments -->
                    <div *ngIf="payment_base.length === 0" class="text-center py-3">
                        <i class="fas fa-money-bill-wave text-muted fz-25"></i>
                        <p class="text-muted small mt-1 mb-0">No se encontraron pagos para esta cuota</p>
                    </div>
                </ng-container>
            </ng-container>

        </ng-container>
    </div>
</div>
